// Copyright (c) 2025 Nebularis Holdings LLC
// Licensed to Nutrx Solutions under a non-exclusive, non-transferable license.
// See IP License Agreement for usage restrictions.
// frontend/src/components/compliance/modals/shared/MetricTile.jsx

import React from "react";
import { Metric } from "../../../../design-system/components";

function toneFromColor(color) {
  const value = String(color || "").toLowerCase();

  if (
    value.includes("34d399") ||
    value.includes("4fd28e") ||
    value.includes("16a34a")
  ) {
    return "success";
  }
  if (
    value.includes("f87171") ||
    value.includes("ff7b7b") ||
    value.includes("dc2626")
  ) {
    return "danger";
  }
  if (
    value.includes("fbbf24") ||
    value.includes("ffcc66") ||
    value.includes("f59e0b")
  ) {
    return "warning";
  }
  if (
    value.includes("60a5fa") ||
    value.includes("6aa8ff") ||
    value.includes("0077ff")
  ) {
    return "informational";
  }
  return "neutral";
}

export default function MetricTile({
  label,
  value,
  sub,
  color = "#34d399",
}) {
  return (
    <Metric
      label={label}
      value={value}
      supportingText={sub}
      tone={toneFromColor(color)}
      size="compact"
    />
  );
}
